<app-sidebar [navigation]="navigation" [type]="type" [suppressNav]="suppressNav"></app-sidebar>
<main class="main" [class.ml-0]="suppressNav">
  <div [class]="container">
    <router-outlet></router-outlet>
  </div>
</main>
